/* eslint-disable indent */
import { save } from "save-file";
import React, { Component } from "react";
import { TrashIcon, DownloadIcon } from "../../lib/icons";
import axios from "axios";
import moment from "moment-timezone";
import { toast } from "react-toastify";

export class NotificationsItem extends Component {
  constructor(props) {
    super(props);
    this.downloadHandler = this.downloadHandler.bind(this);
    this.renderText = this.renderText.bind(this);
    this.removeNotification = this.removeNotification.bind(this);
  }
  downloadHandler() {
    const { item } = this.props;
    let iId = item._id;
    toast.success("Downloading File ...");
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/downloadNotifcationFile`,
        {
          fileId: iId,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        if (!response.data || response.data.success === false) {
          toast.error((response.data && response.data.message) || "Unable to download file");
          return;
        }
        save(response.data, item.fileName);
      })
      .catch((error) => {
        // The global axios response interceptor (axiosConfig.js) already
        // redirects to login for an expired/revoked session (401/403
        // "Invalid Token"). This just makes sure the user sees *something*
        // instead of a download that silently does nothing.
        toast.error((error.response && error.response.data && error.response.data.message) || "Unable to download file");
      });
  }
  removeNotification() {
    const { item, onChange } = this.props;
    let iId = item._id;

    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/app/removeNotifcation`,
        {
          fileId: iId,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        if (typeof onChange === "function") {
          onChange();
        }
      })
      .catch((error) => {
        //dispatch(fetchReportListError(error));
      });
  }
  renderText() {
    const { item } = this.props;
    let fileType = "Powerpoint";

    const getStatusLabel = (status, percentComplete) => {
      if (status === "assembling_metadata") return "Assembling export\u2026";
      if (status === "generating_ai_descriptions") return "Generating AI descriptions\u2026";
      const pct = percentComplete != null ? percentComplete : 0;
      return `Rendering pages\u2026 ${Math.round(pct)}%`;
    };

    const renderProgressBar = (status, percentComplete) => {
      const pct = percentComplete != null ? percentComplete : 0;
      const isIndeterminate = status === "assembling_metadata" || status === "generating_ai_descriptions";
      return (
        <div className="notification-progress-track">
          <div
            className={`notification-progress-fill${isIndeterminate ? " indeterminate" : ""}`}
            style={isIndeterminate ? {} : { width: `${pct}%` }}
          />
        </div>
      );
    };

    if (item.notifyType !== "IMAGE") {
      if (item.notifyType === "PDF") {
        fileType = "PDF";
      } else if (item.notifyType === "PNG") {
        fileType = "PNG Zip";
      }
      if (item.status === "complete") {
        return (
          <div style={{ display: "flex", flexDirection: "row", fontSize: "14px" }}>
            {moment(item.created).format("MM/DD/YY hh:mm A")}{" "}
            <i style={{ marginLeft: "5px", marginRight: "5px" }}>{item.name}</i> {fileType} is ready for download
          </div>
        );
      } else if (item.status === "error" || item.status === "failed") {
        return (
          <div style={{ display: "flex", flexDirection: "row", fontSize: "14px" }}>
            {moment(item.created).format("MM/DD/YY hh:mm A")}{" "}
            <i style={{ marginLeft: "5px", marginRight: "5px" }}>{item.name}</i> <b>failed to export</b>
          </div>
        );
      } else {
        return (
          <div style={{ fontSize: "14px" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {moment(item.created).format("MM/DD/YY hh:mm A")}{" "}
              <i style={{ marginLeft: "5px", marginRight: "5px" }}>{item.name}</i>
            </div>
            <div className="notification-status-step">{getStatusLabel(item.status, item.percentComplete)}</div>
            {renderProgressBar(item.status, item.percentComplete)}
          </div>
        );
      }
    } else {
      fileType = "Image";
      if (item.status === "complete") {
        return (
          <div style={{ display: "flex", flexDirection: "row", fontSize: "14px" }}>
            {moment(item.created).format("MM/DD/YY hh:mm A")}{" "}
            <i style={{ marginLeft: "5px", marginRight: "5px" }}>{item.name}</i> {fileType} added to powerpoint builder
          </div>
        );
      } else {
        return (
          <div style={{ fontSize: "14px" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {moment(item.created).format("MM/DD/YY hh:mm A")}{" "}
              <i style={{ marginLeft: "5px", marginRight: "5px" }}>{item.name}</i>
            </div>
            <div className="notification-status-step">{getStatusLabel(item.status, item.percentComplete)}</div>
            {renderProgressBar(item.status, item.percentComplete)}
          </div>
        );
      }
    }
  }
  render() {
    const { item } = this.props;
    return (
      <div style={{ width: "98%" }}>
        <div style={{ display: "flex", flexDirection: "row", fontSize: "14px" }}>
          {this.renderText()}
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              flexDirection: "row",
            }}>
            {item.status === "complete" &&
              (item.noDownload === null || item.noDownload === undefined || item.noDownload === false) && (
                <div
                  style={{ marginLeft: "auto", color: "rgba(0, 126, 167, 1)" }}
                  onClick={() => {
                    this.downloadHandler();
                  }}>
                  <DownloadIcon
                    height={"16px"}
                    width={"16px"}
                    color={"rgba(88, 89, 91, 1)"}
                    style={{
                      cursor: "pointer",
                      marginRight: "10px",
                      marginBottom: "3px",
                    }}
                  />
                </div>
              )}
            <div
              onClick={() => {
                this.removeNotification();
              }}
              style={{ cursor: "pointer" }}>
              <TrashIcon style={{ marginTop: "-2px", marginLeft: "auto" }} height={"16"} color={"rgba(88, 89, 91, 1)"} />
            </div>
          </div>
        </div>
        <hr />
      </div>
    );
  }
}
